import { createFileRoute, Link } from "@tanstack/react-router";
import { Trophy, Radio, Megaphone } from "lucide-react";
import { JoinAmbassadorCard } from "@/components/ambassadors/JoinAmbassadorCard";
import { RouteTopBar } from "@/components/layout/RouteTopBar";
import { AmbassadorRanking } from "@/components/ambassadors/AmbassadorRanking";
import { NationalCrewsWidget } from "@/components/ambassadors/NationalCrewsWidget";
import { AmbassadorMissions } from "@/components/ambassadors/AmbassadorMissions";
import { CommunityEnergyTicker } from "@/components/ambassadors/CommunityEnergyTicker";
import { CreatorLinkBuilder } from "@/components/ambassadors/CreatorLinkBuilder";
import { CreatorBoostHalo } from "@/components/ambassadors/CreatorBoostHalo";
import { usePersistedCreatorSource } from "@/lib/ambassadors/creatorLinks";
import { WorldCupTagline } from "@/components/brand/WorldCupTagline";
import { BrandSlogan } from "@/components/brand/BrandSlogan";

export const Route = createFileRoute("/ambassadors")({
  head: () => ({
    meta: [
      { title: "VerseSport Ambassadors — World Cup Program" },
      { name: "description", content: "Únete al ejército mundialista: capitanes nacionales, creators, misiones y rankings virales." },
      { property: "og:title", content: "VerseSport Ambassadors — World Cup Program" },
      { property: "og:description", content: "Únete al ejército mundialista: capitanes nacionales, creators, misiones y rankings virales." },
    ],
  }),
  component: AmbassadorsPage,
});

function AmbassadorsPage() {
  usePersistedCreatorSource();
  return (
    <main className="min-h-screen bg-background">
      <RouteTopBar fallback="/" />
      <div className="mx-auto max-w-3xl space-y-4 px-4 py-6">
      <header className="flex items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <Trophy className="h-6 w-6 text-primary" />
          <h1 className="text-2xl font-black tracking-tight">Ambassador Program</h1>
        </div>
        <CommunityEnergyTicker />
      </header>

      <p className="text-sm text-muted-foreground">
        El ejército orgánico del Mundial: influencers, capitanes nacionales y comunidades unidas para hacer explotar VerseSport.
      </p>
      <BrandSlogan section="splash" size="xs" align="left" />
      <WorldCupTagline size="xs" align="left" withProduct />

      <CreatorBoostHalo label="Featured Creator">
        <JoinAmbassadorCard />
      </CreatorBoostHalo>

      <div className="grid gap-4 md:grid-cols-2">
        <AmbassadorRanking />
        <NationalCrewsWidget />
      </div>

      <AmbassadorMissions />

      <CreatorLinkBuilder />

      <section className="grid gap-2 sm:grid-cols-2">
        <Link to="/media-blitz" className="rounded-2xl border border-border/60 bg-background/70 p-3 active:scale-[0.99]">
          <div className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-widest">
            <Radio className="h-3.5 w-3.5 text-primary" /> Media Blitz Hub
          </div>
          <div className="mt-1 text-xs text-muted-foreground">Clip composer, agenda viral y métricas sponsor-ready.</div>
        </Link>
        <Link to="/creator-studio" className="rounded-2xl border border-border/60 bg-background/70 p-3 active:scale-[0.99]">
          <div className="flex items-center gap-1.5 text-[11px] font-black uppercase tracking-widest">
            <Megaphone className="h-3.5 w-3.5 text-primary" /> Creator Studio
          </div>
          <div className="mt-1 text-xs text-muted-foreground">Tu centro de mando: clips, ranking, links y exports.</div>
        </Link>
      </section>
      </div>
    </main>
  );
}
